// "What's included" — the full package: one-time gate equipment + full ID
// issuance for every student (the per-student ID price, not billed as extras).
const EQUIPMENT: string[] = [
  'Mini PC',
  '24" monitor',
  '2× RFID scanner',
  'SMS sender (8-SIM)',
  'USB scanner extensions',
  'Router',
  'Structured cabling',
  'Movable monitor stand',
]

// Covered by the per-student ID price — the school sends the roster, we do the rest.
const PER_ID_INCLUDES: string[] = [
  'Student photo capture',
  'Student details entered for you',
  "Guardian's SMS number registered",
  'Printed, ready-to-tap RFID card',
]

const List = ({ items }: { items: string[] }) => (
  <ul className="list-unstyled fw-medium mb-0">
    {items.map((item) => (
      <li className="d-flex align-items-center gap-2 mb-2" key={item}>
        <i className="ti ti-check text-primary fs-5"></i>
        <span>{item}</span>
      </li>
    ))}
  </ul>
)

export const EquipmentList = () => {
  return (
    <div className="card border-0 shadow-sm h-100">
      <div className="card-body p-4">
        <h4 className="mb-1">What&apos;s included</h4>
        <p className="text-muted mb-3">Every school gets the hardware, the system, and full ID issuance for each student.</p>

        <h6 className="fw-bold text-uppercase text-muted mb-2">One-time equipment</h6>
        <div className="mb-4">
          <List items={EQUIPMENT} />
        </div>

        <h6 className="fw-bold text-uppercase text-muted mb-2">Every student ID (priced per ID)</h6>
        <List items={PER_ID_INCLUDES} />
      </div>
    </div>
  )
}
